export default __webpack_public_path__ + "static/Mask-Group-2@2x-e70261287c256fd47f448c37014e83b3.png";